import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../utils/Api";
import NavElement from "./NavElement";
import WindowDimensions from "../utils/WindowDimensions";

class MenuBar extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        modulStatusCases: PropTypes.object.isRequired,
        handleStatusCase: PropTypes.func.isRequired,
    };

    static defaultProps = {
        activePage: 'home',
    };

    constructor(props){

        super(props);

        this.api = new Api();

        this.state = {
            showUpScroll: false,
            showDownScroll: false
        };

        this.translate = this.props.baseData.translate;

        this.userRightSection = 'Module';
        this.warningMessage = 'Warning! One or more features will expire shortly.';
        this.logout = this.logout.bind(this);
        this.checkUserRole = this.checkUserRole.bind(this);
        this.windowDimensions = WindowDimensions.getWindowDimensions()

    }

    logout(evt) {

        evt.preventDefault();

        this.api.logout(true);

    }

    componentDidUpdate() {

        setTimeout(() => {
            this.scrollHandle();
        }, 500);

    }

    navigate(event, target) {

        event.preventDefault();

        if (this.props.baseData.pageNavigation) this.props.baseData.pageNavigation(target);

    }

    scrollHandle() {

        if(!this.scrollContainer) return;

        const scrollBoxHeight = (this.scrollContainer.clientHeight) ? this.scrollContainer.clientHeight : 0;
        const scrollBoxTop = (this.scrollContainer.scrollTop) ? this.scrollContainer.scrollTop : 0;
        const scrollBoxTopMax = (this.scrollContainer.scrollTopMax) ? this.scrollContainer.scrollTopMax : 0;
        const childrenHeight = (this.scrollContainer.children[0].clientHeight) ? this.scrollContainer.children[0].clientHeight : 0;

        let showUpScroll = false;
        let showDownScroll = false;

        if (scrollBoxHeight < childrenHeight) {
            if (scrollBoxTop > 0) showUpScroll = true;
            if (scrollBoxTop < scrollBoxTopMax) showDownScroll = true;
        }

        if (showUpScroll !== this.state.showUpScroll || showDownScroll !== this.state.showDownScroll) {
            this.setState({
                showUpScroll: showUpScroll,
                showDownScroll: showDownScroll,
            });
        }

    }

    checkIsActivePage(pages) {

        return pages.includes(this.props.activePage);

    }

    checkModulWarning(modulPages) {

        let statusCases = this.props.modulStatusCases;

        return modulPages.some((page) => {
            if (typeof statusCases[this.userRightSection + '-' + page] !== 'undefined') {
                if (statusCases[this.userRightSection + '-' + page] !== 'ok') {
                    return true;
                }
            }

            return false;
        });

    }

    checkUserRole(role) {

        let status = 'locked';
        let user = this.props.baseData.userData;

        if (this.props.baseData.checkUserRole(role.toLowerCase())) status = 'ok';
/*
        if (user.initialized) {
            let hasRole = user.roles.includes(role.toLowerCase());

            if (hasRole) status = 'ok';
        }
*/
        return status;

    }

    getTranslationButton() {

        if (!this.props.baseData.checkUserRole('translations')) return null;

        return (
            <NavElement label={this.translate('translations')}
                        labelKey="translations"
                        linkTo="translations"
                        classes="translations"
                        expandedTag="translations"
                        webImgSrc={require("../img/nav/sidenav/web/translate-default.svg").default}
                        mobilImgSrc={require("../img/nav/sidenav/mobil/translate-mobil.svg").default}
                        activeElement={this.checkIsActivePage(['translations'])}
                        handleNavigation={this.props.baseData.pageNavigation}
            />
        );

    }

    getAccountButton() {

        if (this.props.baseData.checkUserRole('superadmin')) {
            return (
                <NavElement label="MY.Admin"
                            linkTo="admin"
                            classes="admin"
                            expanded={this.checkIsActivePage(['admin', 'adminLicence', 'adminCompanies', 'adminLocations', 'adminMachines', 'adminUsers', 'adminOperator', 'adminOperatorToken', 'adminDatacollector', 'adminOldData', 'treeStructure', 'adminTreeStructure', 'adminSensors', 'adminLogs', 'adminRawData'])}
                            webImgSrc={require("../img/nav/sidenav/web/accounts-default.svg").default}
                            mobilImgSrc={require("../img/nav/sidenav/mobil/accounts-default.svg").default}
                            activeElement={this.checkIsActivePage(['admin', 'adminLicence', 'adminCompanies', 'adminLocations', 'adminMachines', 'adminUsers', 'adminOperator', 'adminOperatorToken', 'adminDatacollector', 'adminOldData', 'treeStructure', 'adminTreeStructure', 'adminSensors', 'adminLogs', 'adminRawData'])}
                            handleNavigation={this.props.baseData.pageNavigation}>
                    <NavElement label={this.translate('licence')}
                                labelKey="licence"
                                linkTo="adminLicence"
                                classes="adminLicence"
                                expandedTag="adminLicence"
                                webImgSrc={require("../img/nav/sidenav/web/licence-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/licence-mobil.svg").default}
                                activeElement={this.checkIsActivePage(['adminLicence'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('companies')}
                                labelKey="companies"
                                linkTo="adminCompanies"
                                classes="companies"
                                expandedTag="adminCompanies"
                                webImgSrc={require("../img/nav/sidenav/web/companies-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/companies-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminCompanies'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('locations')}
                                labelKey="locations"
                                linkTo="adminLocations"
                                classes="adminLocations"
                                expandedTag="adminLocations"
                                webImgSrc={require("../img/nav/sidenav/web/locations-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/locations-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminLocations'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('machines')}
                                labelKey="machines"
                                linkTo="adminMachines"
                                classes="adminMachines"
                                expandedTag="adminMachines"
                                webImgSrc={require("../img/nav/machines-default.svg").default}
                                mobilImgSrc={require("../img/nav/mobile/machines-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminMachines'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('user')}
                                labelKey="user"
                                linkTo="adminUsers"
                                classes="adminUsers"
                                expandedTag="adminUsers"
                                webImgSrc={require("../img/nav/sidenav/web/users-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/users-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminUsers'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('operator')}
                                labelKey="operator"
                                linkTo="adminOperator"
                                classes="adminOperator"
                                expandedTag="adminOperator"
                                webImgSrc={require("../img/nav/sidenav/web/operators-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/operators-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminOperator'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('token')}
                                labelKey="operatorToken"
                                linkTo="adminOperatorToken"
                                classes="adminOperatorToken"
                                expandedTag="adminOperatorToken"
                                webImgSrc={require("../img/nav/sidenav/web/token-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/token-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminOperatorToken'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('dataCollector')}
                                labelKey="dataCollector"
                                linkTo="adminDatacollector"
                                classes="adminDatacollector"
                                expandedTag="adminDatacollector"
                                webImgSrc={require("../img/nav/sidenav/web/datacollector-cloud.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/datacollector-mobil.svg").default}
                                activeElement={this.checkIsActivePage(['adminDatacollector'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('oldData')}
                                labelKey="oldData"
                                linkTo="adminOldData"
                                classes="adminOldData"
                                expandedTag="adminOldData"
                                webImgSrc={require("../img/nav/machines-default.svg").default}
                                mobilImgSrc={require("../img/nav/mobile/machines-default.svg").default}
                                activeElement={this.checkIsActivePage(['oldData'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('treeStructure')}
                                labelKey="treeStructure"
                                linkTo="adminTreeStructure"
                                classes="adminTreeStructure"
                                expandedTag="adminTreeStructure"
                                webImgSrc={require("../img/nav/sidenav/web/software-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/software-mobil.svg").default}
                                activeElement={this.checkIsActivePage(['adminTreeStructure'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('sensors')}
                                labelKey="sensors"
                                linkTo="adminSensors"
                                classes="adminSensors"
                                expandedTag="adminSensors"
                                webImgSrc={require("../img/nav/sidenav/web/miniserver-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/miniserver-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminSensors'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('logFiles')}
                                labelKey="logFiles"
                                linkTo="adminLogs"
                                expandedTag="adminLogs"
                                webImgSrc={require("../img/nav/sidenav/web/logfiles-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/logfiles-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminLogs'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('rawData')}
                                labelKey="rawData"
                                linkTo="adminRawData"
                                expandedTag="adminRawData"
                                webImgSrc={require("../img/nav/sidenav/web/logfiles-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/logfiles-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminRawData'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                </NavElement>
            );
        } else if (this.props.baseData.checkUserRole('zskadmin')) {
            return (
                <NavElement label="MY.Admin"
                            linkTo="admin"
                            classes="admin"
                            expanded={this.checkIsActivePage(['admin', 'adminLicence', 'adminCompanies', 'adminLocations', 'adminMachines', 'adminUsers', 'adminOperator', 'adminOperatorToken', 'adminDatacollector', 'adminOldData', 'adminSensors', 'adminLogs', 'adminRawData'])}
                            webImgSrc={require("../img/nav/sidenav/web/accounts-default.svg").default}
                            mobilImgSrc={require("../img/nav/sidenav/mobil/accounts-default.svg").default}
                            activeElement={this.checkIsActivePage(['admin', 'adminLicence', 'adminCompanies', 'adminLocations', 'adminMachines', 'adminUsers', 'adminOperator', 'adminOperatorToken', 'adminDatacollector', 'adminOldData', 'adminSensors', 'adminLogs', 'adminRawData'])}
                            handleNavigation={this.props.baseData.pageNavigation}>
                    <NavElement label={this.translate('licence')}
                                labelKey="licence"
                                linkTo="adminLicence"
                                classes="adminLicence"
                                expandedTag="adminLicence"
                                webImgSrc={require("../img/nav/sidenav/web/licence-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/licence-mobil.svg").default}
                                activeElement={this.checkIsActivePage(['adminLicence'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('companies')}
                                labelKey="companies"
                                linkTo="adminCompanies"
                                classes="companies"
                                expandedTag="adminCompanies"
                                webImgSrc={require("../img/nav/sidenav/web/companies-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/companies-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminCompanies'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('locations')}
                                labelKey="locations"
                                linkTo="adminLocations"
                                classes="adminLocations"
                                expandedTag="adminLocations"
                                webImgSrc={require("../img/nav/sidenav/web/locations-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/locations-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminLocations'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('machines')}
                                labelKey="machines"
                                linkTo="adminMachines"
                                classes="adminMachines"
                                expandedTag="adminMachines"
                                webImgSrc={require("../img/nav/machines-default.svg").default}
                                mobilImgSrc={require("../img/nav/mobile/machines-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminMachines'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('user')}
                                labelKey="user"
                                linkTo="adminUsers"
                                classes="adminUsers"
                                expandedTag="adminUsers"
                                webImgSrc={require("../img/nav/sidenav/web/users-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/users-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminUsers'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('operator')}
                                labelKey="operator"
                                linkTo="adminOperator"
                                classes="adminOperator"
                                expandedTag="adminOperator"
                                webImgSrc={require("../img/nav/sidenav/web/operators-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/operators-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminOperator'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('token')}
                                labelKey="operatorToken"
                                linkTo="adminOperatorToken"
                                classes="adminOperatorToken"
                                expandedTag="adminOperatorToken"
                                webImgSrc={require("../img/nav/sidenav/web/token-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/token-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminOperatorToken'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('dataCollector')}
                                labelKey="dataCollector"
                                linkTo="adminDatacollector"
                                classes="adminDatacollector"
                                expandedTag="adminDatacollector"
                                webImgSrc={require("../img/nav/sidenav/web/datacollector-cloud.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/datacollector-mobil.svg").default}
                                activeElement={this.checkIsActivePage(['adminDatacollector'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('oldData')}
                                labelKey="oldData"
                                linkTo="adminOldData"
                                classes="adminOldData"
                                expandedTag="adminOldData"
                                webImgSrc={require("../img/nav/machines-default.svg").default}
                                mobilImgSrc={require("../img/nav/mobile/machines-default.svg").default}
                                activeElement={this.checkIsActivePage(['oldData'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('rawData')}
                                labelKey="rawData"
                                linkTo="adminRawData"
                                expandedTag="adminRawData"
                                webImgSrc={require("../img/nav/sidenav/web/logfiles-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/logfiles-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminRawData'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                </NavElement>
            );
        } else if (this.props.baseData.checkUserRole('companyadmin')) {
            return (
                <NavElement label="MY.Admin"
                            linkTo="admin"
                            classes="admin"
                            expanded={this.checkIsActivePage(['admin', 'adminLicence', 'adminLocations', 'adminMachines', 'adminUsers', 'adminOperator', 'adminOperatorToken', 'adminDatacollector', 'adminRawData'])}
                            webImgSrc={require("../img/nav/sidenav/web/accounts-default.svg").default}
                            mobilImgSrc={require("../img/nav/sidenav/mobil/accounts-default.svg").default}
                            activeElement={this.checkIsActivePage(['admin', 'adminLicence', 'adminLocations', 'adminMachines', 'adminUsers', 'adminOperator', 'adminOperatorToken', 'adminDatacollector', 'adminRawData'])}
                            handleNavigation={this.props.baseData.pageNavigation}>
                    <NavElement label={this.translate('licence')}
                                labelKey="licence"
                                linkTo="adminLicence"
                                classes="adminLicence"
                                expandedTag="adminLicence"
                                webImgSrc={require("../img/nav/sidenav/web/licence-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/licence-mobil.svg").default}
                                activeElement={this.checkIsActivePage(['adminLicence'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('locations')}
                                labelKey="locations"
                                linkTo="adminLocations"
                                classes="adminLocations"
                                expandedTag="adminLocations"
                                webImgSrc={require("../img/nav/sidenav/web/companies-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/companies-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminLocations'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
					<NavElement label={this.translate('machines')}
								labelKey="machines"
								linkTo="adminMachines"
								classes="adminMachines"
								expandedTag="adminMachines"
								webImgSrc={require("../img/nav/machines-default.svg").default}
								mobilImgSrc={require("../img/nav/mobile/machines-default.svg").default}
								activeElement={this.checkIsActivePage(['adminMachines'])}
								handleNavigation={this.props.baseData.pageNavigation}
					/>
                    <NavElement label={this.translate('user')}
                                labelKey="user"
                                linkTo="adminUsers"
                                classes="adminUsers"
                                expandedTag="adminUsers"
                                webImgSrc={require("../img/nav/sidenav/web/users-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/users-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminUsers'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('operator')}
                                labelKey="operator"
                                linkTo="adminOperator"
                                classes="adminOperator"
                                expandedTag="adminOperator"
                                webImgSrc={require("../img/nav/sidenav/web/operators-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/operators-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminOperator'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('token')}
                                labelKey="operatorToken"
                                linkTo="adminOperatorToken"
                                classes="adminOperatorToken"
                                expandedTag="adminOperatorToken"
                                webImgSrc={require("../img/nav/sidenav/web/token-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/token-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminOperatorToken'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('dataCollector')}
                                labelKey="dataCollector"
                                linkTo="adminDatacollector"
                                classes="adminDatacollector"
                                expandedTag="adminDatacollector"
                                webImgSrc={require("../img/nav/sidenav/web/datacollector-cloud.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/datacollector-mobil.svg").default}
                                activeElement={this.checkIsActivePage(['adminDatacollector'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                    <NavElement label={this.translate('rawData')}
                                labelKey="rawData"
                                linkTo="adminRawData"
                                expandedTag="adminRawData"
                                webImgSrc={require("../img/nav/sidenav/web/logfiles-default.svg").default}
                                mobilImgSrc={require("../img/nav/sidenav/mobil/logfiles-default.svg").default}
                                activeElement={this.checkIsActivePage(['adminRawData'])}
                                handleNavigation={this.props.baseData.pageNavigation}
                    />
                </NavElement>
            );
        }

        return null;

    }

    renderSetupButton() {

        if (!this.props.baseData.checkUserRole('superadmin') && !this.props.baseData.checkUserRole('zskadmin') && !this.props.baseData.checkUserRole('companyadmin')) return null;

        return (
            <NavElement label={this.translate('setup')}
                        labelKey="setup"
                        linkTo="setup"
                        classes="setup"
                        status={this.props.handleStatusCase('Module', 'setup')}
                        expandedTag="setup"
                        webImgSrc={require("../img/nav/setup-default.svg").default}
                        mobilImgSrc={require("../img/nav/mobile/setup-default.svg").default}
                        activeElement={this.checkIsActivePage(['setup'])}
                        translate={this.translate}
                        handleNavigation={this.props.baseData.pageNavigation}
            />
        );

    }

    renderApiButton() {
        const userData = this.props.baseData.userData;
        const companies = this.props.baseData.companies;
        const currentCompany = companies ? companies.getCurrentCompany() : null;

        let apiEnabled = false;
        if (userData && userData.api_enabled) {
            apiEnabled = true;
        } else if (currentCompany && currentCompany.api_enabled) {
            apiEnabled = true;
        }

        if (!apiEnabled) return null;

        return (
            <NavElement label="API"
                        linkTo="api"
                        classes="api"
                        webImgSrc={require("../img/nav/sidenav/web/software-default.svg").default}
                        mobilImgSrc={require("../img/nav/sidenav/mobil/software-mobil.svg").default}
                        activeElement={this.checkIsActivePage(['api'])}
                        handleNavigation={this.props.baseData.pageNavigation}
            />
        );

    }

    render() {

        const scrollUpClasses = ["scroll-up", (this.state.showUpScroll) ? 'showScroll' : ''].join(' ').trim();
        const scrollDownClasses = ["scroll-down", (this.state.showDownScroll) ? 'showScroll' : ''].join(' ').trim();
        const translationButton = this.getTranslationButton();
        const setupButton = this.renderSetupButton();
        const accountButton = this.getAccountButton();
        const apiButton = this.renderApiButton();

        return (
            <div>
                {/*<!-- Hauptnavigationsleiste links -->*/}
                <div className="nav-panel is-visible">
                    <div className="nav-panel-container">
                        <nav className="vertical directional-nav">
                            <div className="navinnen">
                                <div>
                                    <ul className="logoBox">
                                        <NavElement elementId="myzsk-logo"
                                                    linkTo="home"
                                                    classes="home"
                                                    webImgSrc={require("../img/nav/home-default.svg").default}
                                                    mobilImgSrc={require("../img/nav/mobile/myzsk-default.svg").default}
                                                    handleNavigation={this.props.baseData.pageNavigation}
                                        />
                                    </ul>
                                </div>

                                <div className="scrollBox">
                                    <div className={scrollUpClasses}>&nbsp;</div>

                                    <div className="scrollable"
                                         ref={(scrollContainer) => this.scrollContainer=scrollContainer}
                                         onScroll={this.scrollHandle.bind(this)}
                                         style={{height: this.windowDimensions['scrollBoxHeight']}}>
                                        <ul>
                                            <NavElement label="MY.Analysis"
                                                        linkTo="analysis"
                                                        classes="analysis"
                                                        status={this.props.handleStatusCase('Product', 'analysis')}
                                                        modulWarning={this.checkModulWarning(['machines', 'reports', 'designs', 'setup', 'alarms'])}
                                                        expanded={this.checkIsActivePage(['analysis', 'machines', 'reports', 'designs', 'setup', 'alarms'])}
                                                        expandedTag="analysis"
                                                        webImgSrc={require("../img/nav/reports-default.svg").default}
                                                        mobilImgSrc={require("../img/nav/mobile/reports-default.svg").default}
                                                        activeElement={this.checkIsActivePage(['analysis', 'machines', 'reports', 'designs', 'setup', 'alarms'])}
                                                        handleNavigation={this.props.baseData.pageNavigation}>
                                                <NavElement label={this.translate('machines')}
                                                            labelKey="machines"
                                                            linkTo="machines"
                                                            classes="machines"
                                                            status={this.props.handleStatusCase('Module', 'machines')}
                                                            expandedTag="machines"
                                                            webImgSrc={require("../img/nav/machines-default.svg").default}
                                                            mobilImgSrc={require("../img/nav/mobile/machines-default.svg").default}
                                                            activeElement={this.checkIsActivePage(['machines'])}
                                                            translate={this.translate}
                                                            handleNavigation={this.props.baseData.pageNavigation}
                                                />
                                                <NavElement label={this.translate('reports')}
                                                            labelKey="reports"
                                                            linkTo="reports"
                                                            classes="reports"
                                                            status={this.props.handleStatusCase('Module', 'reports')}
                                                            expandedTag="reports"
                                                            webImgSrc={require("../img/nav/reports-default.svg").default}
                                                            mobilImgSrc={require("../img/nav/mobile/reports-default.svg").default}
                                                            activeElement={this.checkIsActivePage(['reports'])}
                                                            translate={this.translate}
                                                            handleNavigation={this.props.baseData.pageNavigation}
                                                />
                                                <NavElement label={this.translate('designs')}
                                                            labelKey="designs"
                                                            linkTo="designs"
                                                            classes="designs"
                                                            status={this.props.handleStatusCase('Module', 'designs')}
                                                            expandedTag="designs"
                                                            webImgSrc={require("../img/nav/patterns-default.svg").default}
                                                            mobilImgSrc={require("../img/nav/mobile/muster-default.svg").default}
                                                            activeElement={this.checkIsActivePage(['designs'])}
                                                            translate={this.translate}
                                                            handleNavigation={this.props.baseData.pageNavigation}
                                                />
                                                <NavElement label={this.translate('alarms')}
                                                            labelKey="alarms"
                                                            linkTo="alarms"
                                                            classes="alarms"
                                                            status={this.props.handleStatusCase('Module', 'alarms')}
                                                            expandedTag="alarms"
                                                            webImgSrc={require("../img/nav/sidenav/web/alarms-default.svg").default}
                                                            mobilImgSrc={require("../img/nav/sidenav/mobil/alarms-default.svg").default}
                                                            activeElement={this.checkIsActivePage(['alarms'])}
                                                            translate={this.translate}
                                                            handleNavigation={this.props.baseData.pageNavigation}
                                                />
                                                {setupButton}
                                            </NavElement>

                                            {/*<NavElement label="MY.Service"
                                                        linkTo="service"
                                                        classes="service"
                                                        status={this.props.handleStatusCase('Product', 'service')}
                                                        expandedTag="service"
                                                        webImgSrc={require("../img/nav/sidenav/web/service-default.svg").default}
                                                        mobilImgSrc={require("../img/nav/mobile/settings-default.svg").default}
                                                        activeElement={this.checkIsActivePage(['service'])}
                                                        handleNavigation={this.props.baseData.pageNavigation}>
                                            </NavElement>*/}

                                            <NavElement label="MY.Academy"
                                                        linkTo="academy"
                                                        classes="academy"
                                                        status={this.props.handleStatusCase('Product', 'academy')}
                                                        expandedTag="academy"
                                                        webImgSrc={require("../img/nav/sidenav/web/service-default.svg").default}
                                                        mobilImgSrc={require("../img/nav/mobile/settings-default.svg").default}
                                                        activeElement={this.checkIsActivePage(['academy'])}
                                                        handleNavigation={this.props.baseData.pageNavigation}>
                                            </NavElement>

                                            <NavElement label="MY.Video"
                                                        linkTo="video"
                                                        classes="video"
                                                        status={this.props.handleStatusCase('Product', 'video')}
                                                        expandedTag="video"
                                                        webImgSrc={require("../img/nav/sidenav/web/videos2-default.svg").default}
                                                        mobilImgSrc={require("../img/nav/sidenav/mobil/videos2-mobil.svg").default}
                                                        activeElement={this.checkIsActivePage(['video'])}
                                                        handleNavigation={this.props.baseData.pageNavigation}>
                                            </NavElement>

                                            <NavElement label="MY.Software"
                                                        linkTo="software"
                                                        classes="software"
                                                        status={this.props.handleStatusCase('Product', 'software')}
                                                        webImgSrc={require("../img/nav/sidenav/web/software-default.svg").default}
                                                        mobilImgSrc={require("../img/nav/sidenav/mobil/software-mobil.svg").default}
                                                        activeElement={this.checkIsActivePage(['software'])}
                                                        handleNavigation={this.props.baseData.pageNavigation}>
                                            </NavElement>

                                            <NavElement label="MY.Accessories"
                                                        linkTo="accessories"
                                                        classes="accessories"
                                                        status={this.props.handleStatusCase('Product', 'accessories')}
                                                        webImgSrc={require("../img/nav/sidenav/web/accessories-default.svg").default}
                                                        mobilImgSrc={require("../img/nav/sidenav/mobil/accessories-mobil.svg").default}
                                                        activeElement={this.checkIsActivePage(['accessories'])}
                                                        handleNavigation={this.props.baseData.pageNavigation}>
                                            </NavElement>

                                            {translationButton}

                                            {apiButton}

                                            {accountButton}

                                            <NavElement label={this.translate('logoff')}
                                                        linkTo="logoff.html"
                                                        classes="logoff mobilElement"
                                                        webImgSrc={require("../img/nav/i_logoff.svg").default}
                                                        mobilImgSrc={require("../img/nav/i_logoff.svg").default}
                                                        onClick={this.logout}>
                                            </NavElement>
                                            {/* Hover-effekt für Menue <li className="active-bar-vertical">asasd</li>*/}
                                        </ul>
                                    </div>

                                    <div className={scrollDownClasses}>&nbsp;</div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
                {/*<!-- / Hauptnavigationsleiste links -->*/}
            </div>
        );
    }
}

/*
    <NavElement label="MY.Video"
                linkTo="video"
                status={this.props.handleStatusCase('Product', 'video')}
                modulWarning={this.checkModulWarning(['videoFree', 'videoPayment'])}
                expanded={this.checkIsActivePage(['video', 'videoFree', 'videoPayment'])}
                webImgSrc={require("../img/nav/dashboard-default.svg").default}
                mobilImgSrc={require("../img/nav/mobile/dashboard-default.svg").default}
                activeElement={this.checkIsActivePage(['video', 'videoFree', 'videoPayment'])}
                handleNavigation={this.props.baseData.pageNavigation}>
        <NavElement label="Free"
                    labelKey="free"
                    linkTo="videoFree"
                    status={this.props.handleStatusCase('Module', 'videoFree')}
                    expandedTag="videoFree"
                    webImgSrc={require("../img/nav/machines-default.svg").default}
                    mobilImgSrc={require("../img/nav/mobile/machines-default.svg").default}
                    activeElement={this.checkIsActivePage(['videoFree'])}
                    translate={this.translate}
                    handleNavigation={this.props.baseData.pageNavigation}
        />
        <NavElement label="Payment"
                    labelKey="payment"
                    linkTo="videoPayment"
                    status={this.props.handleStatusCase('Module', 'videoPayment')}
                    expandedTag="videoPayment"
                    webImgSrc={require("../img/nav/patterns-default.svg").default}
                    mobilImgSrc={require("../img/nav/mobile/muster-default.svg").default}
                    activeElement={this.checkIsActivePage(['videoPayment'])}
                    translate={this.translate}
                    handleNavigation={this.props.baseData.pageNavigation}
        />
    </NavElement>
 */

export default MenuBar;